module.exports = __webpack_public_path__ + "thx.73530b3f.png";